var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9946,
    cy: 28.0063,
    r: 28.0063,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.875 19.0938C17.2181 19.0938 15.875 20.4369 15.875 22.0937V33.9062C15.875 35.5631 17.2181 36.9062 18.875 36.9062H39.125C40.7819 36.9062 42.125 35.5631 42.125 33.9062V27.3148H15.8755V23.2042H42.125V22.0938C42.125 20.4369 40.7819 19.0938 39.125 19.0938H18.875ZM18.4572 33.1658C18.4572 32.6135 18.905 32.1658 19.4572 32.1658H25.6335C26.1858 32.1658 26.6335 32.6135 26.6335 33.1658C26.6335 33.7181 26.1858 34.1658 25.6335 34.1658H19.4572C18.905 34.1658 18.4572 33.7181 18.4572 33.1658ZM19.4572 28.9688C18.905 28.9688 18.4572 29.4165 18.4572 29.9688C18.4572 30.5211 18.905 30.9688 19.4572 30.9688H30.3671C30.9194 30.9688 31.3671 30.5211 31.3671 29.9688C31.3671 29.4165 30.9194 28.9688 30.3671 28.9688H19.4572Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.20578efc6219fe4835b4e2c53845a288.svg";
export { ForwardRef as ReactComponent };